<template>
  <div>
    <p>{{ $t('Password was reset.') }}</p>
    <router-link to="/login">{{ $t('Go to login page.') }}</router-link>
  </div>
</template>

<script>
import jaTranslations from '@/i18n/langs/ja';
import enTranslations from '@/i18n/langs/en';

export default {
  name: 'Success',
  i18n: {
    en: {
      ...enTranslations,
    },
    ja: {
      ...jaTranslations,
    },
  },
};
</script>

<style scoped>
div {
  padding: 20px 60px;
  text-align: center;
}
</style>
